import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CostFormula } from "@/components/CostFormula";

/**
 * ShowMath — the single way a calculated number is displayed.
 * The value is always clickable and reveals exactly how it was derived.
 * Screens never recompute; they render what the backend pricing engine returned.
 */
export function ShowMath({ label, value, rows = [], summary, testid, tone = "text-slate-900", accent }) {
  const headStyle = accent ? { background: `${accent}14`, borderColor: `${accent}33` } : undefined;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className={`math-value font-mono tabular-nums ${tone}`}
        >
          {value}
        </button>
      </PopoverTrigger>
      <PopoverContent
        className={`w-96 p-0 shadow-lg ${accent ? "" : "border-indigo-200"}`}
        style={accent ? { borderColor: `${accent}55` } : undefined}
        data-testid={testid ? `${testid}-math` : "show-the-math-modal"}
      >
        <div className={`border-b px-4 py-2.5 ${accent ? "" : "bg-indigo-50 border-indigo-100"}`} style={headStyle}>
          <div className={`text-xs font-semibold uppercase tracking-wider ${accent ? "" : "text-indigo-900"}`} style={accent ? { color: accent } : undefined}>
            {label}
          </div>
        </div>
        <div className="p-4 space-y-2 max-h-80 overflow-auto">
          {rows.map((r, i) => (
            <div key={i} className="text-xs">
              {r.title && (
                <div className="text-slate-500 uppercase tracking-wide text-[10px] mb-1 mt-1">{r.title}</div>
              )}
              <div className="font-mono text-slate-700 bg-slate-50 border border-slate-200 rounded px-2 py-1.5 leading-relaxed break-words"
                style={r.color ? { borderLeftColor: r.color, borderLeftWidth: 3 } : undefined}>
                {typeof r.text === "string" ? <CostFormula text={r.text} /> : r.text}
              </div>
            </div>
          ))}
          {summary && (
            <div className="pt-1">
              <div className="font-mono text-xs text-indigo-950 bg-indigo-50 border border-indigo-200 rounded px-2 py-2 font-semibold break-words"
                style={accent ? { color: accent, background: `${accent}12`, borderColor: `${accent}44` } : undefined}>
                {typeof summary === "string" ? <CostFormula text={summary} /> : summary}
              </div>
            </div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
